(function(){
    'use strict';

    angular
       .module('appback')
       .factory('SerialService', SerialService);

   SerialService.$inject = ['$http',"$uibModal"];

   function SerialService($http,$uibModal){

    let port = null; // El puerto serie actual
    this.openModal = false;
    this.enableSerial = false;
    this.loadPortsFromStorage = function() {
        const storedPorts = JSON.parse(localStorage.getItem('serialPorts'));
        if (storedPorts && Array.isArray(storedPorts)) {
            console.log('Cargando puertos desde localStorage:', storedPorts);
            navigator.serial.getPorts().then((ports) =>{
              ports.forEach(port =>{
                var infoPort = port.getInfo();
                storedPorts.forEach(portInfo => {
                    if(portInfo.usbVendorId==infoPort.usbVendorId){
                      console.log("NCONTRADO");
                      
                      this.openSerialPort(port); // Reabrir cada puerto
                    }
                });
                console.log("puerto info", port.getInfo())
              })
              console.log("puertos disponibles", ports)
            });
            
        }
    };
    this.savePortToStorage = function(port) {
        if (port) {
            const portInfo = this.getPortInfo(port);
            console.log("port",portInfo);

            // Obtener los puertos ya guardados
            const storedPorts = JSON.parse(localStorage.getItem('serialPorts')) || [];
            storedPorts.push(portInfo); // Añadir el nuevo puerto al array

            // Guardar todos los puertos en localStorage
            localStorage.setItem('serialPorts', JSON.stringify(storedPorts));
        }
    };

    this.getPortInfo = function(port) {
        return port.getInfo();
      };
    // Solicitar un puerto serie
    this.requestPort = function() {
        navigator.serial.requestPort().then((port) => {
            console.log("Puerto seleccionado:", port);
        
            // Abre el puerto con la tasa de baudios, no puedes configurar directamente los bits de datos y stopbits
            port.open({ baudRate: 38400 }).then(() => {
                console.log('puerto serie abierto',port);
                this.getPortInfo(port); // Obtener la info del puerto ahora que está abierto
                this.savePortToStorage(port); // Guardar el puerto en localStorage
                this.readFromPort(port); // Comienza a leer datos
                    this.enableSerial = true;
            })
            .catch(function(error) {
            console.error('Error al abrir el puerto serie: ', error);
            });
        }).catch((err) => {
            console.error("Error al seleccionar el puerto:", err);
        });
      };

    // Abrir el puerto serie con una tasa de baudios
    this.openSerialPort = function(port) {
      port.open({ baudRate: 38400 })
        .then(function() {
          console.log('Puerto serie abierto');
                this.enableSerial = true;
          this.readFromPort(port); // Comienza a leer datos
        }.bind(this)) // Aseguramos el contexto de `this` en la promesa
        .catch(function(error) {
          console.error('Error al abrir el puerto serie: ', error);
        });
    };

    this.popupMaquina = false;
    this.abrirPopup = function(){
        this.popupMaquina = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-top',
                ariaDescribedBy: 'modal-body-top',
                //windowClass: 'modal-danger',
                //backdrop  : 'static',
                templateUrl: 'maquinacurso.html',
                size: 'sm',
                controller: function($scope) {
                  // Función quie inicializa los comentarios para llamarla con ng-change
                  
                  $scope.okForm = function(){
                    this.popupMaquina.close();
                            this.openModal = false;

                  }
                  $scope.koForm = function(){
                      this.popupMaquina.close();
                            this.openModal = false;

                  }
                }
          });
    }

    // Leer datos desde el puerto serie
    this.readFromPort = function(port) {
      const reader = port.readable.getReader();
      const decoder = new TextDecoder(); // Para convertir los datos binarios a texto
      let receivedData = '';
      const self = this;

      function readLoop() {
        reader.read()
          .then(function({ value, done }) {
            if (done) return; // Si ya no hay más datos, salir del bucle

            if(!self.openModal){
              self.abrirPopup();
              self.openModal = true;
            }
            const text = decoder.decode(value);
            receivedData += text;
            console.log('Datos recibidos:', receivedData); // Aquí podrías manejar los datos de la manera que necesites
            let lines = receivedData.split('\n');
            if (lines.length > 1) {
              // Procesa las líneas completas
              lines.forEach((line, index) => {
                  if (index < lines.length - 1) {
                      console.log("Línea completa recibida:", line);
                      if(line.startsWith("*T")){
                          console.log("RESULTADO")
                          self.guardarLectura(line,function(data){
                            console.log("data", data);
                            self.popupMaquina.close();
                            self.openModal = false;

                          });
                      }
                  }
              });

              // Mantiene los datos incompletos (si los hay) para la siguiente lectura
              receivedData = lines[lines.length - 1];
          }
            readLoop(); // Llamar recursivamente para seguir leyendo
          })
          .catch(function(error) {
            console.error('Error al leer del puerto serie: ', error);
          });
      }

      readLoop(); // Iniciar la lectura
    };

    this.guardarLectura = function(lectura,callback){
      console.log("lectura", lectura);
      var config = {
          headers : {
              'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
          }
      }

      var data = $.param({
         lectura:lectura
      });
      $http.post('/backend/maquinaslog/guardarlectura', data, config)
      .then(getContentSuccess,getContentFailed);
      function getContentSuccess(data){ 
          callback(data.data);
      }
      function getContentFailed(data){
          return false;
      }
  }

    
    // Cerrar el puerto serie
    this.closePort = function() {
      if (port && port.open) {
        port.close()
          .then(function() {
            console.log('Puerto serie cerrado');
          })
          .catch(function(error) {
            console.error('Error al cerrar el puerto serie:', error);
          });
      }
    };
    return this;
} })();
